const labels = { id: "شناسه", title: "نام", provinceId: "شناسه استان", province: "استان",
  cityId: "شناسه شهر", city: "شهر", advertisements: "تعداد آگهی‌ها", regions: "تعداد مناطق" };
const camel = (key) => key[0].toLowerCase() + key.slice(1);
export function geographyTableResponse(payload) {
  const data = (payload.data || []).map((row) => Object.fromEntries(Object.entries(row).map(([key, value]) => [camel(key), value])));
  const header = (payload.header || []).map((column) => {
    const name = camel(column.name);
    const result = { ...column, name, title: labels[name] || column.title };
    if (name === "advertisements" || name === "regions") return { ...result, type: "objectfield", link: "length" };
    if ((name === "province" || name === "city") && data.some((row) => row[name] && typeof row[name] === "object")) {
      data.forEach((row) => { if (row[name]) row[name] = { ...row[name], title: row[name].title ?? row[name].Title }; });
      return { ...result, type: "objectfield", link: "title" };
    }
    return result;
  });
  return { ...payload, data, header };
}
